import { createStyles } from 'antd-style';

import { flex1 } from '../../styles/mixins';
import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';
import { FA_SELECTOR } from '../../styles/variables';

export const useAccordionStyles = createStyles(({ token }) => ({
  accordion: {
    '&.Accordion--fullHeight': {
      height: '100%',

      '&, .Accordion__Item': {
        display: 'flex',
        flexDirection: 'column',
      },

      '.Accordion__Item.Accordion__Item--active, .Accordion__Body.Accordion__Body--active':
        {
          ...flex1(),
        },
    },

    '&.Accordion--isInFlexContainer.Accordion--fullHeight': {
      ...flex1(),

      '.Accordion__Body': {
        display: 'flex',
        flexDirection: 'column',

        '> *': {
          ...flex1(),
        },
      },
    },
  },

  accordionItem: {
    marginBottom: ThemeSpaces.SPACE_NORM,
  },
  accordionHeaderActive: {
    '&&': {
      marginBottom: ThemeSpaces.SPACE_NORM,
    },
  },
  accordionHeader: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: ThemeColors.COLOR_GREY_BLUISH,
    borderRadius: token.borderRadiusSM,
    height: 30,
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 'bold',
    color: token.colorWhite,
    padding: 0,
    cursor: 'pointer',
    marginBottom: 0,
    transition: `margin-bottom ${token.motionDurationMid} ease-in-out`,

    [FA_SELECTOR]: {
      padding: `0 ${ThemeSpaces.SPACE_NORM0_5}px`,
    },
  },
}));
